// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Phpw","blank":"_339F1","button":"_2F2Gd"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/AnswerBlock/AnswerBlock.scss
// module id = 1174
// module chunks = 2